import getStore from '../data/store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return getStore(); },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function isKeyboardShortcutsOptionDirty(state) {
    var userOptions = state.userOptions, optionState = state.optionState;
    return (getFallbackValueIfNull(optionState.shortcuts, userOptions.KeyboardShortcutsMode) !==
        userOptions.KeyboardShortcutsMode);
});
//# sourceMappingURL=isKeyboardShortcutsOptionDirty.js.map